/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Pribyl (pribyl@cadwork.cz)
 *
 */

import Factory from "App/animations/interpolators/factory"
import Interpolator from "App/animations/interpolators/interpolator"
import {vec3} from "gl-matrix";

export default
class TimeLoop extends Interpolator {
    public static TypeName: string = "TimeLoop";

    constructor() {
        super();

        this._typeName = TimeLoop.TypeName;
    }

    public static create(): TimeLoop {
        return new TimeLoop();
    }

    public interpolate(aFrameA: any, aFrameB: any, aTimeDiff: number): {position: vec3, target: vec3} {
        return {position: vec3.create(), target: vec3.create()}
    }
}

Factory.register(TimeLoop);
